import _regeneratorRuntime from "/home/syntaxval/Documents/Work.2017/StellarFox/redshift/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Asynchronous tools.
 *
 * @module async
 * @license Apache-2.0
 * @author drmats
 */

import { head } from "./array";
import { curry, identity, Y } from "./func";
import { inc } from "./math";
import { quote } from "./string";
import { isArray, isFunction } from "./type";
import { timeUnit } from "./utils";
export var cancellable = function cancellable(p) {
  var mutex = createMutex();
  return {
    promise: race(p, mutex.lock()),
    cancel: mutex.reject,
    resolve: mutex.resolve
  };
};
export var createMutex = function createMutex() {
  var resolve = null,
      reject = null,
      promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    lock: function lock() {
      return promise;
    },
    resolve: resolve,
    reject: reject
  };
};
export var delay = function delay() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : timeUnit.second;
  var passCancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  return timeout(function () {
    return time;
  }, time, passCancel);
};
export var interval = function interval(f) {
  var passClear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : timeUnit.second;

  var resolve = null,
      handle = null,
      result = null,
      clear = function clear() {
    clearInterval(handle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    resolve.apply(void 0, _toConsumableArray(args.length > 0 ? args : [result]));
    return result;
  },
      promise = new Promise(function (res, rej) {
    resolve = res;
    handle = setInterval(function () {
      try {
        result = f(clear);
      } catch (ex) {
        clearInterval(handle);
        rej(ex);
      }
    }, time);
  });

  passClear(clear);
  return promise;
};
export var map = curry(function (arr, f) {
  var results = [],
      i = 0,
      resolve = null,
      promise = new Promise(function (res) {
    resolve = res;
  }),
      progress = function progress(r) {
    results.push(r);
    i = inc(i);

    if (i < arr.length) {
      Promise.resolve(f.call(arr, arr[i], i)).then(progress).catch(progress);
    } else resolve(results);
  },
      bquote = function bquote(x) {
    return quote(typeof x, "[]");
  };

  if (isArray(arr) && isFunction(f)) {
    if (arr.length > 0) {
      Promise.resolve(f.call(arr, head(arr), 0)).then(progress).catch(progress);
    } else return Promise.resolve(results);
  } else throw new TypeError("async.map() expected array and function, " + "got ".concat(bquote(arr), " and ").concat(bquote(f)));

  return promise;
});
export var parMap = curry(function (arr, f) {
  return Promise.all(arr.map(function (el) {
    return Promise.resolve(f(el));
  }));
});
export var race = function race() {
  var mutex = createMutex(),
      resolved = false;

  for (var _len2 = arguments.length, ps = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    ps[_key2] = arguments[_key2];
  }

  ps.forEach(function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(p) {
      var v, e, thrown;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              v = null, e = null, thrown = false;
              _context.prev = 1;
              _context.next = 4;
              return p;

            case 4:
              v = _context.sent;
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              e = _context.t0;
              thrown = true;

            case 11:
              if (!resolved) {
                resolved = true;
                if (!thrown) mutex.resolve(v);else mutex.reject(e);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  return mutex.lock();
};
export var reduce = curry(function (arr, f, initAcc) {
  var i = 0,
      resolve = null,
      promise = new Promise(function (res) {
    resolve = res;
  }),
      progress = function progress(r) {
    i = inc(i);

    if (i < arr.length) {
      Promise.resolve(f.call(arr, r, arr[i], i)).then(progress).catch(progress);
    } else resolve(r);
  },
      bquote = function bquote(x) {
    return quote(typeof x, "[]");
  };

  if (isArray(arr) && isFunction(f)) {
    if (arr.length > 0) {
      Promise.resolve(f.call(arr, initAcc || head(arr), head(arr), 0)).then(progress).catch(progress);
    } else return Promise.resolve(initAcc);
  } else throw new TypeError("async.reduce() expected array and function, " + "got ".concat(bquote(arr), " and ").concat(bquote(f)));

  return promise;
});
export var repeat = curry(function (f, condition) {
  return Y(function (act) {
    return function (result) {
      return condition() ? Promise.resolve().then(f).then(act) : Promise.resolve(result);
    };
  })();
});
export var timeout = function timeout(f) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : timeUnit.second;
  var passCancel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  var reject = null,
      handle = null,
      promise = new Promise(function (res, rej) {
    reject = rej;
    handle = setTimeout(function () {
      try {
        res(f());
      } catch (ex) {
        rej(ex);
      }
    }, time);
  });
  passCancel(function (reason) {
    clearTimeout(handle);
    reject(reason);
  });
  return promise;
};